import { format } from 'date-fns'

import { mbonusApi } from 'redux/services/mbonus'
import { MBonusObject } from 'redux/services/mbonus/types'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { MBONUS_STATUS_TEXT } from 'constants/mbonus'

import { LabledInfo } from 'shared/ui'

import styles from './Details.module.scss'

interface DetailsProps {
  id: MBonusObject['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } =
    mbonusApi.useGetMBonusByIdQuery(id)

  function renderValue(label: string, key: keyof MBonusObject) {
    if (data?.[key]) {
      return <LabledInfo label={label}>{data?.[key]}</LabledInfo>
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={data.name} />
        <div className={styles.container}>
          {renderValue('ID', 'id')}
          {renderValue('Наименование', 'name')}
          {renderValue('ИНН', 'inn')}
          {renderValue('ID Jira', 'jira_key')}
          {renderValue('Адрес', 'get_full_address')}
          {renderValue('Размер кешбека', 'cashback')}
          <LabledInfo label="Категория клиента">
            {data.field_activity?.name || '-'}
          </LabledInfo>
          <LabledInfo label="Количество ТТ">
            {data.count_points}
          </LabledInfo>
          <LabledInfo label="Дата создания">
            {format(new Date(data.created_at), 'dd.MM.yyyy HH:mm')}
          </LabledInfo>

          <LabledInfo label="Статус">
            {MBONUS_STATUS_TEXT[data.status]}
          </LabledInfo>
          <LabledInfo label="Способ оплаты">
            {data.payment_method.name}
          </LabledInfo>

          <LabledInfo label="Комментарий">
            {data.comments?.map(c => {
              return (
                <div className={styles.comment}>
                  <p>{c.text}</p>
                  <span>
                    {format(new Date(c.created_at), 'dd.MM.yyyy HH:mm')}
                  </span>
                </div>
              )
            })}
          </LabledInfo>

          {data.consultant ? (
            <div className={styles.item}>
              <div className={styles.itemName}>Консультант</div>
              <div className={styles.itemText}>
                <strong>ФИО:</strong>
                <span>{data.consultant.full_name}</span>
              </div>
              <div className={styles.itemText}>
                <strong>Телефон:</strong>
                <span>{data.consultant.phone}</span>
              </div>
              <div className={styles.itemText}>
                <strong>Филиал:</strong>
                <span>
                  {data.consultant.main_branch || data.consultant.branches}
                </span>
              </div>
              <div className={styles.itemText}>
                <strong>ИНН:</strong>
                <span>{data.consultant.inn}</span>
              </div>
            </div>
          ) : null}
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
